import FontFaceObserver from 'fontfaceobserver'

/**
 * @file Defines the {@link FontLoader} class
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

/** Class for handling Loading custom fonts */
export class FontLoader {

    /** File types to load */
    types = {

        'woff2':    'woff2',
        'woff':     'woff',
        'ttf':      'truetype',
        'otf':      'opentype'

    }

    /** Hidden CSS style string for font preloads */
    style = 'position:absolute!important;top:0!important;left:0!important;z-index:-100000!important;opacity:0!important;pointer-events:none!important;'

    /** HTML wrapper for load elements */
    container

    /** HTML wrapper for font face definitions */
    fontFaceContainer

    /** Generate CSS font face source definition */
    source(name_, weight_, type_) {

        let filename    = `font_${name_.toLowerCase().replace(/ /, '-')}_${weight_}.${type_}`   //Filename to load

        return `url('font/${filename}') format('${this.types[type_]}')`

    }

    /** Required asset loading method */
    load(font_) {

        let elem                    = document.createElement('p')   //Element to initiate load
        let { name, weight, url }   = font_                         //Font details
        weight                      = weight || 'normal'            //Default weight
        elem.innerHTML              = name                          //Add some text
        elem.style.cssText          = this.style              //Hide element
        elem.style.fontFamily       = name                          //Set font family
        elem.style.fontWeight       = String(weight)                //Set font weight 

        //If font requires external font file
        if (url) {

            let sources = this.source(name, String(weight), url)    //Generate font face sources

            //Initialise font face definition
            let fontFace = `@font-face { font-family: ${name}; weight: ${weight}; src: ${sources};`

            //If container for font faces not already initialised
            if (!this.fontFaceContainer) {
                
                this.fontFaceContainer = document.createElement('style')  //Create container for font faces
                document.body.appendChild(this.fontFaceContainer)         //Add container to page

            }

            this.fontFaceContainer.textContent += fontFace //Initiate load

        }

        //If container not already initialised
        if (!this.container) {
                
            this.container = this.container = document.createElement('div')    //Create container
            document.body.appendChild(this.container)                                //Add container to page

        }

        this.container.appendChild(elem) //Initiate load

        //Return Promise for font load complete
        return (new FontFaceObserver(font_.name, { weight })).load(null, 5000)

    }

}